import React, { createContext, useContext, useState, useEffect } from 'react';

interface BookmarkContextType {
  bookmarks: string[];
  addBookmark: (path: string) => void;
  removeBookmark: (path: string) => void;
  isBookmarked: (path: string) => boolean;
}

const BookmarkContext = createContext<BookmarkContextType | undefined>(undefined);

export const BookmarkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [bookmarks, setBookmarks] = useState<string[]>([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedBookmarks = localStorage.getItem('calculatorBookmarks');
      if (savedBookmarks) {
        setBookmarks(JSON.parse(savedBookmarks));
      }
    }
  }, []);

  const addBookmark = (path: string) => {
    const newBookmarks = [...bookmarks, path];
    setBookmarks(newBookmarks);
    if (typeof window !== 'undefined') {
      localStorage.setItem('calculatorBookmarks', JSON.stringify(newBookmarks));
    }
  };

  const removeBookmark = (path: string) => {
    const newBookmarks = bookmarks.filter(b => b !== path);
    setBookmarks(newBookmarks);
    if (typeof window !== 'undefined') {
      localStorage.setItem('calculatorBookmarks', JSON.stringify(newBookmarks));
    }
  };

  const isBookmarked = (path: string) => bookmarks.includes(path);

  return (
    <BookmarkContext.Provider value={{ bookmarks, addBookmark, removeBookmark, isBookmarked }}>
      {children}
    </BookmarkContext.Provider>
  );
};

export const useBookmarks = () => {
  const context = useContext(BookmarkContext);
  if (context === undefined) {
    throw new Error('useBookmarks must be used within a BookmarkProvider');
  }
  return context;
};